import React from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useThemeObserver } from '@atlaskit/tokens';

import type { ProductKey } from '../../../types';

import backgroundDark from './assets/background-dark.svg';
import backgroundLight from './assets/background-light.svg';
import { FeatureNameColumn } from './feature-name-column';
import { FloatingRecommendation } from './floating-recommendation';
import { PremiumEditionColumn } from './premium-edition-column';
import { StandardEditionColumn } from './standard-edition-column';

/**
 * This is the right side panel depicted here:
 * https://www.figma.com/design/gN2uHK0wPD93kkqExPlNeM/Confluence%3A-Recommend-Standard-to-RT-trialing-customers-(RT)?node-id=3730-11924&node-type=frame&t=ZS7oExyVxcrlRkJQ-0
 */
export const FeatureComparisonPanel = ({
	productKey,
	standardPrice,
	premiumPrice,
}: {
	productKey: ProductKey;
	standardPrice: number;
	premiumPrice: number;
}) => {
	const { colorMode } = useThemeObserver();
	const isConfluence = productKey === 'Confluence';

	return (
		<>
			<FloatingRecommendation />
			<Box xcss={colorMode === 'dark' ? panelStylesDark : panelStylesLight}>
				<Flex xcss={tableStyles} alignItems="center" justifyContent="center">
					<FeatureNameColumn isConfluence={isConfluence} />
					<StandardEditionColumn standardPrice={standardPrice} />
					<PremiumEditionColumn premiumPrice={premiumPrice} />
				</Flex>
			</Box>
		</>
	);
};

const panelStylesLight = xcss({
	width: '484px',
	height: '536px',
	position: 'absolute',
	'@media all': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		background: `url(${backgroundLight}) no-repeat`,
	},
});

const panelStylesDark = xcss({
	width: '484px',
	height: '536px',
	position: 'absolute',
	'@media all': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		background: `url(${backgroundDark}) no-repeat`,
	},
});

const tableStyles = xcss({
	top: '120px',
	position: 'relative',
});
